<app-card [title]="'user.editUser.labels.employmentInfo'" titleSize="large">
    <ng-template #content>
        @let organizations = store.uniqueOrganizations();
        @if (organizations) {
            <app-table
                [tableTitle]="'user.editUser.employmentInfo.organizations'"
                [gridData]="$any(organizations)"
                [columns]="columns"
                translatePrefix="user.editUser.employmentInfo."
                [hideCheckboxes]="true"
            >
                <ng-template pTemplate="years" let-item="item">
                    {{ item.earliestDate | age }}
                </ng-template>
            </app-table>
        }

        @let services = store.uniqueServices();
        @if (services) {
            <app-table
                [tableTitle]="'user.editUser.employmentInfo.services'"
                [gridData]="$any(services)"
                [columns]="columns"
                translatePrefix="user.editUser.employmentInfo."
                [hideCheckboxes]="true"
            >
                <ng-template pTemplate="years" let-item="item">
                    {{ item.earliestDate | age }}
                </ng-template>
            </app-table>
        }
    </ng-template>
</app-card>
